import { Directive, ElementRef, OnInit, Renderer2, inject, input } from '@angular/core';
export type GlassGlowTheme = '' | 'aurora' | 'sunset' | 'ocean';
const GLASS_SPANS = [
  'glass-glow-orb3',
  'glass-glow-orb4',
  'glass-glow-orb5',
  'glass-shape-ring1',
  'glass-shape-ring2',
  'glass-shape-ring3',
  'glass-shape-tri1',
  'glass-shape-tri2',
  'glass-shape-hex'
];
@Directive({
  selector: '[fuseGlassGlow]',
  exportAs: 'fuseGlassGlow'
})
export class GlassGlowDirective implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  readonly theme = input<GlassGlowTheme>('', { alias: 'fuseGlassGlow' });
  ngOnInit(): void {
    const host = this.el.nativeElement;
    this.renderer.addClass(host, 'glass-glow-bg');
    const theme = this.theme();
    if (theme) {
      this.renderer.addClass(host, `glass-glow--${theme}`);
    }
    GLASS_SPANS.forEach(cls => {
      const span = this.renderer.createElement('span');
      this.renderer.addClass(span, cls);
      this.renderer.setAttribute(span, 'aria-hidden', 'true');
      this.renderer.insertBefore(host, span, host.firstChild);
    });
  }
}
